export function formatToBRL(num: number) {
    return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        .replace(/-R\$\s/g, 'R$ -');
}

/**
 * Máscara para o filtro "Quantia": apenas dígitos (últimos 2 = centavos), formato pt-BR.
 * Permite sinal negativo para valores negativos no extrato.
 */
export function applyQuantiaBuscaMask(rawInput: string): string {
    let neg = false;
    let s = rawInput;
    if (s.startsWith("-")) {
        neg = true;
        s = s.slice(1);
    }
    const digits = s.replace(/\D/g, "").slice(0, 15);
    if (!digits) {
        return neg ? "-" : "";
    }
    const n = (neg ? -1 : 1) * (parseInt(digits, 10) / 100);
    return n.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

/**
 * Converte o valor mascarado (ex.: "1.234,56") em string decimal com ponto para a API (busca exata).
 */
export function brlMaskedToDecimalApiString(masked: string): string | null {
    const t = masked.trim();
    if (!t || t === "-") return null;
    const neg = t.startsWith("-");
    const body = (neg ? t.slice(1) : t).trim().replace(/\s/g, "");
    const commaIdx = body.lastIndexOf(",");
    let intPart: string;
    let decPart: string;
    if (commaIdx === -1) {
        intPart = body.replace(/\./g, "");
        decPart = "00";
    } else {
        intPart = body.slice(0, commaIdx).replace(/\./g, "");
        decPart = body.slice(commaIdx + 1);
    }
    if (!intPart && !decPart.replace(/0/g, "")) return null;
    const dec2 = (decPart + "00").slice(0, 2);
    const n = parseFloat(`${neg ? "-" : ""}${intPart || "0"}.${dec2}`);
    if (!Number.isFinite(n)) return null;
    return n.toFixed(2);
}

function sumBRL(brl1:string, brl2:string) {
    var num1 = Number(brl1.replace("R$", "").replace(/\./g, "").replace(",", "."));
    var num2 = Number(brl2.replace("R$", "").replace(/\./g, "").replace(",", "."));

    var sum = num1 + num2;
    return sum.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}